module.exports = __webpack_public_path__ + "img/20200512_162645.1131bd57.jpg";